import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { trackActivity } from './auth/session';
// <axon-chat> renders in IBM Plex Sans. Served from our own origin, not Google
// Fonts, so loading the page tells no third party who is using chat. Same
// weights the Google Fonts link loaded; 700 and italics are still synthesized.
import '@fontsource/ibm-plex-sans/400.css';
import '@fontsource/ibm-plex-sans/500.css';
import '@fontsource/ibm-plex-sans/600.css';
import './index.css';

// For the idle limit: past it, the token is no longer refreshed.
trackActivity();

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('missing #root element');

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
